
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/most-favored-nation",
      function () {
        return require("private-next-pages/most-favored-nation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/most-favored-nation"])
      });
    }
  